import { ContactView } from '../views';
export default ContactView;
